import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/image-caption.module.css';

const ImageCaption = ({ tag = 'figcaption', className = null, ...props }: TypographyProps) => {
    return (
        <Typography tag={tag} className={classNames([styles.container, className])} {...props} />
    );
};

export default ImageCaption;
